module.exports = __webpack_public_path__ + "static/media/11_avatar_female.64d36d1e.png";